import React from "react";
import Loader from "./Loader";

const Button = ({ loading, onClick, children }) => {
  return (
    <button
      disabled={loading}
      onClick={onClick}
      className={`flex items-center justify-center w-fit font-semibold leading-[24px] px-4 first:sm:text-lg capitalize bg-zinc-200 text-zinc-800 rounded-xl h-10 ${
        loading ? "opacity-50 cursor-not-allowed" : ""
      }`}
    >
      {loading && (
        <span className="h-10">
          <Loader />
        </span>
      )}
      {children}
    </button>
  );
};

export default Button;
